<template lang="pug">
  v-dialog(
    v-model="_value" 
    max-width="400"
    )
    v-card
      v-card-title.font-weight-medium.text-uppercase.primary.white--text Seleccionar columnas
      v-data-table(
        hide-actions
        select-all
        v-bind="tableProps"
        v-model="selected"
        item-key="value"
        )
        template( slot="items" slot-scope="props" )
          tr( :active="props.selected" )
            td( @click="props.selected = !props.selected" )
              v-checkbox( hide-details :input-value="props.selected" )
            td( class='text-uppercase' ) {{ props.item.text }}
      v-card-actions
        v-btn( 
          block 
          color='primary' 
          depressed 
          :disabled='selected.length === columns.length'
          @click='selectAll' 
          ) seleccionar todas &nbsp;
          v-icon done_all
</template>

<script>
  export default {
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      columns: {
        type: Array,
        default: [],
      },
    },
    data () {
      return {
        selected: [],
        selectorHeaders: [{ text: 'COLUMNA', sortable: true, width: '90%' }],        
      }
    },
    computed: {
      tableProps() {
        return {
          headers: this.selectorHeaders,
          items: this.columns.slice(0, -1),
        }
      },
      _value: {
        get() {
          return this.value
        },
        set(v) {
          this.$emit('input', v)
        },
      },
    },
    methods: {
      selectAll() {
        this.selected = this.columns
      },
    },
    watch: {
      columns: {
        immediate: true,
        handler(v) {
          this.selected = this.columns
        },
      },
      selected: {
        immediate: true,
        handler(v) {

          this.$emit('columns:active', this.columns.filter(item => {
            return v.some(column => {
              return column.text === item.text
            })
          }))
        },
      },
    },
  }
</script>
